import React from "react";
import { Typography, Box, List, ListItem, ListItemText, Divider, Grid, Button, Chip } from "@mui/material";

const BedroomAndHome = ({ prevStep, nextStep }) => {
  const rules = [
    "Make your bed every day",
    "Clean your bedroom regularly using the vacuum, mop, spray and wipe.",
    "Turn off all electrical equipment after use",
    "Open your blinds/curtains during the daytime",
    "Always clean up after yourself",
    "Keep the home clean and tidy",
  ];

  return (
    <Box className='house-rules-container'>
      <Box className='header-section-house'>
        <Chip label='Admission' />
        <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
          House Rules
        </Typography>
        <br />
        <Divider className='divider' />
      </Box>
      <Box className='content-section'>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
          Bedroom and Home
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          "Ensure your bedroom remains tidy and organized, meeting cleanliness standards through daily <br />
          and weekly routines."
        </Typography>
        <List className='rules-list'>
          {rules.map((rule, index) => (
            <ListItem key={index} className='rule-item'>
              <ListItemText primary={<Typography sx={{ fontSize: "14px", color: "black" }}>{rule}</Typography>} />
            </ListItem>
          ))}
        </List>
      </Box>

      <Grid container justifyContent='space-between' alignItems='center' mt={2} ml={1} mr={2}>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={prevStep}>
            Previous
          </Button>
        </Grid>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={nextStep}>
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BedroomAndHome;
